var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.67157 18H4.67156C3.56699 18 2.67156 17.1045 2.67157 16L2.67164 4.00001C2.67165 2.89545 3.56708 2.00002 4.67165 2.00002H13.6719C14.7764 2.00002 15.6719 2.89545 15.6719 4.00002V9.50002M14.5 17.6569V14.8284M14.5 14.8284V12M14.5 14.8284L11.6716 14.8284M14.5 14.8284L17.3284 14.8284M6.17188 6.00002H12.1719M6.17188 9.00002H12.1719M6.17188 12H9.17188",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus);
export default __webpack_public_path__ + "static/media/file-plus.0b1d4d6fc0bb6b54abb7b0e25e953a59.svg";
export { ForwardRef as ReactComponent };